import { PageNavigatorRedirect } from "@-/dev.improve.haniverse.lib.navigator.page";
import { BrowsePrimitivesListSkeleton } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs._components.loading-skeletons";
import { useBrowsePrimitivesListPageNavigator } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.primitives.list.navigator";

/**
 * Primitives tab entry: redirects to the List route on its first render, showing the same grouped
 * grid skeleton the Primitives layout uses as its loading state, so nothing jumps while the list
 * loads behind it.
 */
export function BrowsePrimitivesIndexPage() {
  const navigator = useBrowsePrimitivesListPageNavigator();
  return (
    <PageNavigatorRedirect navigator={navigator} prefetchQueryKey="browsePrimitivesIndexPage">
      <BrowsePrimitivesListSkeleton />
    </PageNavigatorRedirect>
  );
}
